import { ChevronNextIcon } from '@svgs'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, MyModal } from 'src/components/ui'
import HowItWorks from 'src/components/pages/home/sections/how/HowItWorks'
import banner from '@images/home/banner.jpg'
import { IProperty } from 'src/interfaces/IProperty'

interface IInfoBanner {
  property?: IProperty
}

const InfoBanner: FC<IInfoBanner> = () => {
  const { t } = useTranslation()
  // The instruction is the cabinet's "how it works" section; a guest cannot
  // open the cabinet, so the button shows it here. It used to do nothing.
  const [howOpen, setHowOpen] = useState(false)
  // Компонент не зависит от данных объявления, но мы добавили пропс для совместимости.
  // It sits at the end of the listing column: text on the left and the photo
  // fading in on the right on a desktop, the photo under the text on a phone.
  return (
    <div className="relative flex flex-col md:flex-row overflow-hidden w-full md:min-h-[13rem] text-white bg-inverse rounded-2xl">
      <div className="relative z-10 flex flex-col items-start gap-3 p-5 md:p-7 md:w-3/5">
        <h3 className="m-0 text-[1.375rem] font-black leading-7">{t('banner.sidebar_title')}</h3>
        <p className="m-0 text-base leading-6 text-white/80">{t('banner.description_1')}</p>
        <Button
          variant={'secondary'}
          iconAfter={<ChevronNextIcon />}
          onClick={() => setHowOpen(true)}
        >
          {t('property.view')}
        </Button>
      </div>
      <MyModal
        open={howOpen}
        handleClose={() => setHowOpen(false)}
        width="w-[calc(100%_-_2rem)] max-w-[56rem]"
      >
        <HowItWorks embedded />
      </MyModal>
      <div className="relative h-36 md:h-auto md:absolute md:inset-y-0 md:right-0 md:w-1/2 pointer-events-none touch-none">
        <img loading="lazy" src={banner} alt="" className="object-cover size-full" />
        <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-r from-inverse to-transparent" />
      </div>
    </div>
  )
}

export default InfoBanner
